import noScroll from 'no-scroll';

export default class NoScrollController {
  idMap = {};

  /** The CSS `scroll-behavior` property of the document at the time of intialization (for JS clients only) */
  private initialScrollBehavior?: string;

  private IS_JS_ENV = typeof document !== 'undefined';

  constructor() {
    if (this.IS_JS_ENV && document.documentElement) {
      this.initialScrollBehavior = document.documentElement.style.scrollBehavior;
    }
  }

  /**
   * For JavaScript clients, if the modal is open, override the document `scroll-behavior`
   * to prevent the scroll position from "jumping" back and forth when the modal is closed.
   */
  private overrideScrollBehavior = (override: boolean): void => {
    if (!this.IS_JS_ENV || !document.documentElement) {
      return;
    }
    document.documentElement.style.scrollBehavior = override
      ? 'initial'
      : this.initialScrollBehavior || '';
  };

  on = (id: string): void => {
    if (!this.idMap[id]) {
      this.idMap[id] = true;
      noScroll.on();
      this.overrideScrollBehavior(true);
    }
  };

  off = (id: string): void => {
    if (this.idMap[id]) {
      delete this.idMap[id];

      if (Object.keys(this.idMap).length === 0) {
        noScroll.off();
        this.overrideScrollBehavior(false);
      }
    }
  };

  forceOff = (): void => {
    this.idMap = {};
    noScroll.off();
    this.overrideScrollBehavior(false);
  };
}
